module.exports = __webpack_public_path__ + "media/images/lb/811-d29acc8f4044282d84ed24d42a354a59.svg";